"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kushki = void 0;
const Identifiers_1 = require("./../lib/constant/Identifiers");
const KushkiError_1 = require("./../lib/generic/KushkiError");
const CardBrandsEnum_1 = require("./../lib/infrastructure/CardBrandsEnum");
const Container_1 = require("./../lib/infrastructure/Container");
const ErrorEnum_1 = require("./../lib/infrastructure/ErrorEnum");
require("reflect-metadata");
const UtilsService_1 = require("./../lib/service/UtilsService");
const KushkiInfo_1 = require("./../lib/KushkiInfo");
/**
 * Implementation
 */
class Kushki {
    // tslint:disable-next-line:max-func-body-length
    constructor(body) {
        KushkiInfo_1.KInfo.sKushkiInfo = KushkiInfo_1.KInfo.buildKushkiInfo(body.kushkiInfo);
        body.inTestEnvironment =
            body.inTestEnvironment === undefined ? false : body.inTestEnvironment;
        body.regional = body.regional === undefined ? false : body.regional;
        this._merchantId = body.merchantId;
        this._inTestEnvironment = body.inTestEnvironment;
        this._regional = body.regional;
        this._cardService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.CardService)(this._regional);
        this._siftScience = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.SiftScienceService)(this._regional);
        this._transferService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.TransferService)(this._regional);
        this._cashService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.CashService)(this._regional);
        this._multiMerchantInfoService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.MultiMerchantService)(this._regional);
        this._commissionService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.CommissionService)(this._regional);
        this._kushkiService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.KushkiService)(this._regional);
        this._secureService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.SecureService)();
        this._cardAsyncService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.CardAsyncService)();
        this._payoutsCashService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.PayoutsCashService)(this._regional);
        this._payoutsTransferService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.PayoutsTransferService)(this._regional);
        this._transferSubscriptionService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.TransferSubscriptionService)(this._regional);
        this._mobileProcessorService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.MobileProcessorService)();
        this._authService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.AuthService)();
        this._kPayService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.KPayService)();
        this._cardDynamicService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.CardDynamicService)();
        this._cardSubscriptionDynamicService = Container_1.CONTAINER.get(Identifiers_1.IDENTIFIERS.CardSubscriptionDynamicService)();
    }
    requestToken(body, callback) {
        this._cardService.requestToken(body, this._merchantId, this._inTestEnvironment, this._regional, callback);
    }
    requestInitAntiFraud(userId, callback) {
        this._resolve(this._siftScience.requestInitAntiFraud(userId, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    /**
     * @deprecated use requestDeviceToken instead
     * @param {Function} body with value
     * @param {Function} callback with value
     * @returns {void}
     */
    requestTokenCharge(body, callback) {
        this._requestDeviceToken(body, callback);
    }
    requestDeviceToken(body, callback) {
        this._requestDeviceToken(body, callback);
    }
    requestSubscriptionToken(body, callback) {
        this._cardService.requestSubscriptionToken(body, this._merchantId, this._inTestEnvironment, this._regional, callback);
    }
    requestTransferToken(body, callback) {
        this._resolve(this._transferService.requestTransferToken(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    checkStatus(callback) {
        this._resolve(this._kushkiService.checkStatus(this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    /**
     * @deprecated since version 1.19.8 use requestBankList instead
     * @param {Function} callback with value
     * @returns {void}
     */
    requestPseBankList(callback) {
        this._requestBankList(callback);
    }
    requestBankList(callback) {
        this._requestBankList(callback);
    }
    requestDeferred(body, callback) {
        this._resolve(this._cardService.requestDeferred(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestBinInfo(body, callback) {
        this._cardService
            .requestBinInfo(body, this._merchantId, this._inTestEnvironment, this._regional)
            .subscribe({
            error: (err) => Kushki.callbackError(err, callback),
            next: (response) => {
                callback(response);
            },
        });
    }
    requestBrandsByMerchant(callback) {
        this._kushkiService
            .requestBrandsByMerchant(this._merchantId, this._inTestEnvironment, this._regional)
            .subscribe({
            error: (err) => Kushki.callbackError(err, callback),
            next: (response) => {
                callback(response);
            },
        });
    }
    requestBrandsLogosByMerchant(callback) {
        this._kushkiService
            .requestBrandsLogosByMerchant(this._merchantId, this._inTestEnvironment, this._regional)
            .subscribe({
            error: (err) => Kushki.callbackError(err, callback),
            next: (response) => {
                callback(response);
            },
        });
    }
    requestCashToken(body, callback) {
        this._resolve(this._cashService.requestCashToken(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestSecureServiceValidation(body, callback) {
        this._resolve(this._secureService.requestSecureServiceValidation(this._merchantId, body, this._inTestEnvironment, this._regional), callback);
    }
    requestCardAsyncToken(body, callback) {
        this._resolve(this._cardAsyncService.requestCardAsyncToken(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestSubscriptionCardAsyncToken(body, callback) {
        this._resolve(this._cardAsyncService.requestCardSubscriptionAsyncToken(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    multiMerchantInfo(body, callback) {
        this._resolve(this._multiMerchantInfoService.multiMerchantInfo(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestPayoutsCashToken(body, callback) {
        this._resolve(this._payoutsCashService.requestPayoutsCashToken(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestPayoutsTransferToken(body, callback) {
        this._resolve(this._payoutsTransferService.requestPayoutsTransferToken(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    getCommissionConfiguration(body, callback) {
        this._resolve(this._commissionService.getCommissionConfiguration(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestTransferSubscriptionToken(body, callback) {
        this._resolve(this._transferSubscriptionService.requestToken(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestTransferSubscriptionBankList(callback) {
        this._resolve(this._transferSubscriptionService.requestBankList(this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestPayoutsTransferBankList(callback) {
        this._resolve(this._payoutsTransferService.requestPayoutsTransferBankList(this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestMobileProcessorToken(body, callback) {
        this._resolve(this._mobileProcessorService.requestToken(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestCardDynamicToken(bin, body, callback) {
        this._cardDynamicService.requestCardDynamicToken(bin, body, this._merchantId, this._inTestEnvironment, this._regional, callback);
    }
    requestCardSubscriptionDynamicToken(bin, body, callback) {
        this._cardSubscriptionDynamicService.requestCardSubscriptionDynamicToken(bin, body, this._merchantId, this._inTestEnvironment, this._regional, callback);
    }
    requestInitAuth(body, callback) {
        this._resolve(this._authService.requestInitAuth(body, this._inTestEnvironment), callback);
    }
    deletePaymentMethod(body, callback) {
        this._resolve(this._kPayService.deletePaymentMethod(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestSavedPaymentMethods(body, callback) {
        this._resolve(this._kPayService.requestSavedPaymentMethods(body, this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    requestVerifyAuth(body, callback) {
        this._resolve(this._authService.requestVerifyAuth(body.code, this._inTestEnvironment), callback);
    }
    validateSession(callback) {
        this._resolve(this._authService.validateSession(this._inTestEnvironment), callback);
    }
    requestValidate3DS(body, callback) {
        this._cardService.validate3DS(body, this._merchantId, this._inTestEnvironment, this._regional, callback);
    }
    requestSecureInit(body, callback) {
        this._cardService.requestSecureInit(body, this._merchantId, this._inTestEnvironment, this._regional, callback);
    }
    /**
     * @param {Function} callback - function to execute when animation ends.
     * @param {ErrorResponse} [callback.error] - return when throw an error during the animation.
     * @param {VisaBrandingRequest | MasterCardBrandingRequest} body - configurations of the animation.
     * @param {string} body.brand - Visa/MasterCard param - card brand ["visa" | "mastercard"]
     * @param {string} [body.color="white"] - Visa param - The background of animation ["white" | "blue" | "blur"].
     * @param {boolean} [body.constrained=false] - Visa param - The container visualization.
     * @param {boolean} [body.sound=false] - Visa param - The activation of the sound.
     * @param {string} [body.checkmark="none"] - Visa param - The visualization of checkmark ["none" | "checkmark" | "checkmarkWithText"].
     * @param {string} [body.checkmarkTextOption="approved"] - Visa param - The text to appear if checkmarkWithText is enabled ["approved" | "success" | "complete"].
     * @param {string} [body.languageCode="es"] - Visa param - The language of the checkmark text ["es" | "en" | "pt_br"].
     * @param {string} [body.type="default"] - MasterCard param - define type of component ["default" | "animation-only" | "sound-only"].
     * @param {boolean} [body.clearBackground=false] - MasterCard param - clears the background.
     * @returns {void}
     */
    initCardBrandingAnimation(callback, body) {
        switch (body.brand) {
            case CardBrandsEnum_1.CardBrandsEnum.VISA:
                this._kushkiService.initVisaBrandingAnimation(this._inTestEnvironment, callback, body);
                break;
            case CardBrandsEnum_1.CardBrandsEnum.MASTERCARD:
                this._kushkiService.initMasterCardBrandingAnimation(callback, body);
                break;
            default:
                return Kushki.callbackError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E017), callback);
        }
    }
    static callbackError(err, callback) {
        if (err instanceof KushkiError_1.KushkiError)
            callback({
                code: `${err.code}`,
                error: `${err.code} - ${err.getMessage()}`,
                message: `${err.getMessage()}`,
            });
        else
            callback({
                code: `${UtilsService_1.UtilsService.sGet(err, "response.data.code", "K002")}`,
                error: `${UtilsService_1.UtilsService.sGet(err, "message", "Ha ocurrido un error inesperado.")}`,
                message: `${UtilsService_1.UtilsService.sGet(err, "response.data.message", "Ha ocurrido un error inesperado.")}`,
            });
    }
    _requestBankList(callback) {
        this._resolve(this._transferService.requestBankList(this._merchantId, this._inTestEnvironment, this._regional), callback);
    }
    _requestDeviceToken(body, callback) {
        this._cardService.requestDeviceToken(body, this._merchantId, this._inTestEnvironment, this._regional, callback);
    }
    _resolve(observable, callback) {
        observable.subscribe({
            error: (err) => Kushki.callbackError(err, callback),
            next: (response) => {
                callback(response);
            },
        });
    }
}
exports.Kushki = Kushki;
